import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../providers/AuthProvider';
import { CircularProgress, Box } from '@mui/material';

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, validateToken } = useAuth();
  const [isChecking, setIsChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      await validateToken();
      setIsChecking(false);
    };

    checkAuth();
  }, [validateToken]);

  if (isLoading || isChecking) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to the login page with a return url
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return children;
};
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProtectedRoute;
